import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Receipt } from "@/hooks/useReceipts";
import { ReceiptCard } from "./ReceiptCard";

interface ReceiptGridProps {
  receipts: Receipt[];
  loading: boolean;
  loadingMore: boolean;
  hasMore: boolean;
  hasFilters: boolean;
  deletingId: string | null;
  onDelete: (id: string) => Promise<void>;
  onView: (receipt: Receipt) => void;
  onLoadMore: () => void;
}

export function ReceiptGrid({
  receipts,
  loading,
  loadingMore,
  hasMore,
  hasFilters,
  deletingId,
  onDelete,
  onView,
  onLoadMore,
}: ReceiptGridProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  if (receipts.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-8">
        {hasFilters ? "No receipts match your filters." : "No receipts uploaded yet."}
      </p>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {receipts.map((receipt) => (
          <ReceiptCard
            key={receipt.id}
            receipt={receipt}
            onDelete={onDelete}
            onView={onView}
            isDeleting={deletingId === receipt.id}
          />
        ))}
      </div>
      
      {hasMore && (
        <div className="flex justify-center mt-6">
          <Button
            variant="outline"
            onClick={onLoadMore}
            disabled={loadingMore}
          >
            {loadingMore ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Loading...
              </>
            ) : (
              'Load More'
            )}
          </Button>
        </div>
      )}
    </>
  );
}
